import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';
import { statusToTransitionMap } from './appStatusFormUtils';
import { AppId, Group } from '../common/interfaces';

interface State {
    appId?: string;
    name?: string;
    status?: string;
    type?: string;
    groups?: string[];
    areGroupsFetching: boolean;
    availableSearchedGroups: Group[] | null;
    addedGroups?: Group[];
    domainSettings: any;
    domainSettingsRequired: boolean;
    isDomainSettingsTokenFetching: boolean;
    userManual?: string;
    isAvailable?: boolean;
    configurationStatus: {
        [key: string]: {
            isConfigured: boolean;
        };
    } | null;
    domainSettingsToken?: any;
    stateUpdate: {
        transition?: string | null;
        selectedGroups?: Group[];
        collaborationAppsHierarchyAfterUpdate: AppId[];
    };
    isProtectConfigurable?: boolean;
    customData?: {
        [key: string]: string;
    };
}

const initialState: State = {
    groups: [],
    areGroupsFetching: false,
    availableSearchedGroups: [],
    isAvailable: false,
    addedGroups: [],
    domainSettings: null,
    domainSettingsRequired: false,
    isDomainSettingsTokenFetching: false,
    configurationStatus: null,
    stateUpdate: {
        transition: null,
        selectedGroups: [],
        collaborationAppsHierarchyAfterUpdate: [],
    },
    isProtectConfigurable: false,
};
interface Action {
    type:
        | ACTION_TYPE.REQUEST_SEARCH_GROUPS_PENDING
        | ACTION_TYPE.REQUEST_SEARCH_GROUPS_FULFILLED
        | ACTION_TYPE.REQUEST_SEARCH_GROUPS_REJECTED
        | ACTION_TYPE.REQUEST_STATUS_FORM_FULFILLED
        | ACTION_TYPE.REQUEST_GET_ADDED_GROUPS_PENDING
        | ACTION_TYPE.REQUEST_GET_ADDED_GROUPS_FULFILLED
        | ACTION_TYPE.REQUEST_GET_ADDED_GROUPS_REJECTED
        | ACTION_TYPE.CLOSE_STATUS_FORM
        | ACTION_TYPE.REQUEST_DOMAIN_SETTINGS_TOKEN_PENDING
        | ACTION_TYPE.REQUEST_DOMAIN_SETTINGS_TOKEN_REJECTED
        | ACTION_TYPE.REQUEST_DOMAIN_SETTINGS_TOKEN_FULFILLED;
    payload: any;
}

export default createReducerFunction<State, Action>({
    initialState,
    reducers: {
        [ACTION_TYPE.REQUEST_SEARCH_GROUPS_PENDING]: (state) => ({
            ...state,
            areGroupsFetching: false,
            availableSearchedGroups: [],
        }),
        [ACTION_TYPE.REQUEST_SEARCH_GROUPS_FULFILLED]: (state, { payload }) => ({
            ...state,
            areGroupsFetching: false,
            availableSearchedGroups: payload.groups,
        }),
        [ACTION_TYPE.REQUEST_SEARCH_GROUPS_REJECTED]: (state) => ({
            ...state,
            areGroupsFetching: false,
            availableSearchedGroups: null,
        }),
        [ACTION_TYPE.REQUEST_STATUS_FORM_FULFILLED]: (state, { payload }) => ({
            isDomainSettingsTokenFetching: false,
            domainSettingsToken: state.domainSettingsToken ? { ...state.domainSettingsToken } : null,
            ...payload,
            stateUpdate: {
                ...state.stateUpdate,
                transition: statusToTransitionMap[payload.status],
            },
        }),
        [ACTION_TYPE.REQUEST_GET_ADDED_GROUPS_PENDING]: (state) => ({
            ...state,
            areGroupsFetching: true,
            addedGroups: [],
        }),
        [ACTION_TYPE.REQUEST_GET_ADDED_GROUPS_FULFILLED]: (state, { payload }) => ({
            ...state,
            areGroupsFetching: false,
            addedGroups: payload,
            stateUpdate: {
                ...state.stateUpdate,
                selectedGroups: payload.map((addedGroup: Group) => ({ initiallySelected: true, ...addedGroup })),
            },
        }),
        [ACTION_TYPE.REQUEST_GET_ADDED_GROUPS_REJECTED]: (state) => ({
            ...state,
            areGroupsFetching: false,
            addedGroups: [],
        }),
        [ACTION_TYPE.CLOSE_STATUS_FORM]: () => initialState,
        [ACTION_TYPE.REQUEST_DOMAIN_SETTINGS_TOKEN_PENDING]: (state) => ({
            ...state,
            isDomainSettingsTokenFetching: true,
        }),
        [ACTION_TYPE.REQUEST_DOMAIN_SETTINGS_TOKEN_REJECTED]: (state) => ({
            ...state,
            isDomainSettingsTokenFetching: false,
            domainSettingsToken: null,
        }),
        [ACTION_TYPE.REQUEST_DOMAIN_SETTINGS_TOKEN_FULFILLED]: (state, { payload }) => ({
            ...state,
            isDomainSettingsTokenFetching: false,
            domainSettingsToken: payload,
        }),
        [ACTION_TYPE.UPDATE_TRANSITION]: (state, { payload }) => ({
            ...state,
            stateUpdate: {
                ...state.stateUpdate,
                transition: payload.transition,
            },
        }),
        [ACTION_TYPE.UPDATE_SELECTED_GROUPS]: (state, { payload }) => ({
            ...state,
            stateUpdate: {
                ...state.stateUpdate,
                selectedGroups: payload.groups,
            },
        }),
        [ACTION_TYPE.UPDATE_COLLABORATION_APPS_HIERARCHY]: (state, { payload }) => ({
            ...state,
            stateUpdate: {
                ...state.stateUpdate,
                collaborationAppsHierarchyAfterUpdate: payload,
            },
        }),
        [ACTION_TYPE.UPDATE_CUSTOM_DATA]: (state, { payload }) => ({
            ...state,
            stateUpdate: {
                ...state.stateUpdate,
                clientId: payload,
            },
        }),
    },
});
